<template>
  <section id="main-wrap" class="pure-g">
    <div id="main-col" class="pure-u-3-5">

      <h3>{{author}}</h3>

      <div id="home-grapes">
        <Grape v-for="grape in grapes" :grapeInstance="grape" :key="grape.id" />
      </div>

    </div>
  </section>

</template>

<script>
  import Grape from './Grape.vue'
  import db from './firebaseInit'

  export default {
    name: 'author',
    data () {
      return {
        grapeIDs: [],
        grapes: [],
        username: '',
        loading: true,
        search: '',
        author: '',
        enableLoadMore: true,
        grapesDatabase: this.$globals.grapesDatabase,
        isPress: this.$globals.isPress
      }
    },
    created () {
      $('html, body').animate({ scrollTop: 0 }, 'slow')  
      this.author = decodeURI(this.$route.params.name)
      this.fetchData()
      this.$eventHub.$emit('viewing-author-page', this.author)
    },
    watch: {
      '$route': 'fetchData'
    },
    methods: {
      fetchData () {
        this.getAuthorGrapes()
      },
      getAuthorGrapes: function () {
        console.log('getAuthorGrapes: ' + this.author)
        this.grapes = []
        var grapesRef = db.collection(this.grapesDatabase).where('sourceAuthor', '==', this.author).orderBy('updatedTimestamp', 'desc').limit(20)
        grapesRef.get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            console.log('fetch: ' + doc.id, ' => ', doc.data())
            var grapeData = doc.data()
            grapeData.docID = doc.id
            this.grapes.push(grapeData)
          })
        })
      },
      loadMore: function () {
        var vm = this
        if (this.lastVisible && !this.isLoading && this.enableLoadMore) {
          this.isLoading = true
          var grapesRef = db.collection(this.grapesDatabase).where('sourceAuthor', '==', this.author).orderBy('updatedTimestamp', 'desc').startAfter(this.lastVisible).limit(20)
          grapesRef.get().then((querySnapshot) => {
            this.lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1]
            console.log('load more activated, last visible: ' + this.lastVisible.data().id)
            querySnapshot.forEach((doc) => {
              var grapeData = doc.data()
              grapeData.docID = doc.id
              this.grapes.push(grapeData)
            })
            setTimeout(function () {
              vm.isLoading = false
            }, 2000)
          })
        }
      }
    },
    components: {
      Grape
    }
  }
</script>

<style scoped>
  #main-wrap {
    background: #f9f9f9;
    min-height: 100vh;
  }
  #add-grape-button {
    width: 100%;
    margin: 0 auto 20px;
    background: #36a731;
    color: #fff;
    text-align: left;
    font-size: 12px;
    font-weight: bold;
    text-transform: uppercase;
    padding: 15px 20px;
  }
  #search-grapes {
    width: 60%;
    margin: 0 auto 20px;
    line-height: 30px;
    padding-left: 5px;
    padding-right: 5px;
    box-sizing: border-box;
  }
  #home-grapes {
    margin-top: 40px;
  }
  .aux-col {
    box-sizing: border-box;
    padding: 30px 50px;
    text-align: left;
  }
  .aux-col > h5 {
    text-transform: uppercase;
    border-bottom: 1px solid #36a731;
    margin: 0 0 20px;
    padding-bottom: 8px;
    display: inline-block;
  }
</style>


// WEBPACK FOOTER //
// src/components/Author.vue